module.exports = __webpack_public_path__ + "../resources/img/header-logo.1124111c.svg";